export class VobAssignmentRemoveCommand {
    upn: string;
    assignmentValue?: string;
    assignmentType: string;
    processType: string;

    constructor(upn: string, assignmentType: string, processType: string, assignmentValue?: string) {
        this.upn = upn;
        this.assignmentType = assignmentType;
        this.processType = processType;
        this.assignmentValue = assignmentValue;
    }
}
